export default __webpack_public_path__ + "static/map-4a200362c31b998bb3230d945936dce8.jpg";